module.exports = __webpack_public_path__ + "static/page-stolen-by-bad-clowns-dafc3c5e2fbfe54ef802f4ed24dd640f.png";